module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rfrontmatter01"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Introduction#frontmatter01"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homebirth in the Hospital – Making It Happen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Definition of Integrative Childbirth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confidence and Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control of Protocols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter01section07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter01#chapter01section07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Checklist for Evaluating Integrative Childbirth Providers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter02#chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Woman’s Will")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Stacey and Sarah Kate")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do What You Need to Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Pamela and Chloé")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Wants OUT!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Sueli and Marcus")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("As Simple as It Gets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Jennifer and Akayla")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sliding into Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Serena and Sophie")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten Pounds, Fourteen Ounces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Lara and Joseph")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Having Holden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Heather and Holden")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter09"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postgraduate Training")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Renee and Oliver")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter10"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rainbow Wipeouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Laura Clare and Lily")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter11"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Third Time’s the Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Chrissy and Anael")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter12"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intuitive, Introspective, Inspirational")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Lennie and Zan Cayli and Eyan")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter13"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Bobbi and Jesse")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter14"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angels on My Shoulder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Deborah and Gavin")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter15"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Do It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Lucy and Christopher and Katelyn")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter16"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cancer Can’t Wait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Carol and Logan")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter17"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Physicians—How to Be an Integrative Childbirth Provider")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice-Management for Integrative Childbirth Care")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Essential Elements of Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Communication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Continuity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confidence and Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rchapter17section06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#chapter17section06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control of Protocols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Acknowledgements#backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/flo.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Abouttheauthor#backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0